<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-surface-stack" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (dataContext.reverted || dataContext.performedAt) {
        <section class="astral-section-surface astral-stack-m">
          @if (dataContext.reverted) {
            <h3 class="astral-section-heading">{{ 'FEE_CHANGE.REVERTED' | translate }}</h3>
          }
          <!-- Keep the legacy display-only date-time formatter until Astral has an equivalent read-only date-time control. -->
          @if (dataContext.performedAt) {
            <app-date-time-box
              [value]="dataContext.performedAt"
              [label]="'FEE_CHANGE.PERFORMED_AT'"
            ></app-date-time-box>
          }
        </section>
      }
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-date-picker [control]="form.controls['changeFrom']"></astral-date-picker>
          <astral-input [control]="form.controls['changeType']"></astral-input>
          @if (!isImport) {
            <astral-input [control]="form.controls['changeValue']"></astral-input>
          }
          <astral-input [control]="form.controls['webUserName']"></astral-input>
        </astral-layout-group>
        @if (showRetroactive) {
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-date-picker [control]="form.controls['retroactiveFrom']"></astral-date-picker>
            <astral-date-picker [control]="form.controls['retroactiveTo']"></astral-date-picker>
          </astral-layout-group>
        }
      </section>
      @if (dataContext.leaseRowChanges.length || dataContext.templateRowChanges.length) {
        <div class="astral-accordion-stack">
          @if (dataContext.leaseRowChanges.length) {
            <astral-accordion [header]="'CONST.RENTAL_CHANGES_TYPE_AGREEMENT'" [allowWidthExpansion]="true">
              <div class="astral-form-stack astral-form-stack--relaxed">
                <div class="astral-form-actions">
                  <astral-button variant="secondary" type="button" icon="file" labelKey="COMMON.EXCEL" (click)="exportLeaseAgreementsExcel()"></astral-button>
                </div>
                <div class="astral-section-surface">
                  @if (!isIndexChange) {
                    <app-list-view
                      [columnDefinition]="leaseRowColumnDefinitions"
                      [itemsSource]="dataContext.leaseRowChanges"
                      [preferencesKey]="'rent.fee-change.lease-rows'"
                    ></app-list-view>
                  }
                  @if (isIndexChange) {
                    <app-list-view
                      [columnDefinition]="leaseRowIndexColumnDefinitions"
                      [itemsSource]="dataContext.leaseRowChanges"
                      [preferencesKey]="'rent.fee-change.lease-rows-index'"
                    ></app-list-view>
                  }
                </div>
              </div>
            </astral-accordion>
          }
          @if (dataContext.templateRowChanges.length) {
            <astral-accordion [header]="'CONST.RENTAL_CHANGES_TYPE_OBJECT'" [allowWidthExpansion]="true">
              <div class="astral-form-stack astral-form-stack--relaxed">
                <div class="astral-form-actions">
                  <astral-button variant="secondary" type="button" icon="file" labelKey="COMMON.EXCEL" (click)="exportTemplateRowsExcel()"></astral-button>
                </div>
                <div class="astral-section-surface">
                  @if (!isIndexChange) {
                    <app-list-view
                      [columnDefinition]="templateRowColumnDefinitions"
                      [itemsSource]="dataContext.templateRowChanges"
                      [preferencesKey]="'rent.fee-change.template-rows'"
                    ></app-list-view>
                  }
                  @if (isIndexChange) {
                    <app-list-view
                      [columnDefinition]="templateRowIndexColumnDefinitions"
                      [itemsSource]="dataContext.templateRowChanges"
                      [preferencesKey]="'rent.fee-change.template-rows-index'"
                    ></app-list-view>
                  }
                </div>
              </div>
            </astral-accordion>
          }
        </div>
      }
    </form>
  }
</section>
